import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import SplashScreen from 'src/components/SplashScreen';
import { setUserData, logout } from 'src/actions/accountActions';
import authService from 'src/services/authService';
import { useHistory } from 'react-router';

function Auth({ children }) {
	const dispatch = useDispatch();
	const [isLoading, setLoading] = useState(true);
	const pathname = window.location.pathname;
	const urlParams = new URLSearchParams(window.location.search);
	const token = urlParams.get('token');

	const history = useHistory();
	const isPublicRoute =
		pathname.startsWith('/auth') ||
		pathname.startsWith('/validation') ||
		pathname === '/cookie' ||
		pathname === '/404' ||
		pathname === '/500' ||
		pathname === '/emptyConf';

	const initAuth = async () => {
		authService.setAxiosInterceptors({
			onLogout: () => dispatch(logout())
		});

		authService.handleAuthentication();

		if (authService.isAuthenticated()) {
			const user = await authService.loginUsingToken();

			await dispatch(setUserData(user));
		}

		setLoading(false);
	};

	const authG7 = async token => {
		authService.loginG7(token);
		setLoading(false);
		history.push('/app');
	};

	useEffect(() => {
		if (isPublicRoute) {
			setLoading(false);
			return;
		}
		if ((pathname && pathname.includes('g7')) || token) {
			authG7(token);
		} else {
			initAuth();
		}
	}, [dispatch, pathname, token,isPublicRoute]);

	if (isLoading) {
		return <SplashScreen />;
	}

	return children;
}

Auth.propTypes = {
	children: PropTypes.any
};

export default Auth;
